import Modal from '../../../../components/modal';
import './index.css';

const LoadingVoteModal = ()=>{
    return(
        <Modal>
            <div className="golden-ball-voted-screen">
                <p className='golden-ball-voted-title-header'>Votando...</p>
                <img className="loading-vote-logo" src="/balon-oro-logo.png" height={250} width={250} alt="Balon de Oro Logo" />
            </div>

        </Modal>
    )
}

export default LoadingVoteModal